import React, { Fragment } from "react";
import { RotatingLines } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../components/css/style.css";
import "../components/css/popup.css";

export const xAuth = "M@#weh@##dhASD2627@#2024";

/* ############ mtnz service ##########   
export const service="mtnz";
export const countryCode="260";
export const flag="zm";
export const lang="en";
export const serviceId=1;
//export const baseUrl = "/slapi";
export const baseUrl = "https://mtnz.uvcanngaming.com/mtnzApi"; */

/* ############ mtnet service ########## 
export const service="mtnet";
export const countryCode="268";
export const flag="sz";
export const lang="en";
export const serviceId=1;
//export const baseUrl = "/slapi";
export const baseUrl = "https://met.uvcanngaming.com/mtnetApi";  */

/* ############ mtnlb service ########## */
export const service = "mtnlb";
export const countryCode = "231";
export const flag = "lr";
export const lang = "en";
export const serviceId = 1;
//export const baseUrl = "/slapi";
export const baseUrl = "https://mtnlb.uvcanngaming.com/mtnlbApi";

export const brandImages = [
  "/images/brand_1.png",
  "/images/brand_2.png",
  "/images/brand_3.png",
  "/images/brand_4.png",
  "/images/brand_2.png",
  "/images/brand_5.png",
];

export const footerImages = [
  "/images/footer_3.png",
  "/images/footer_2.png",
  "/images/footer_1.png",
  "/images/footer_4.png",
  "/images/footer_5.png",
];

export const Loader = () => {
  return (
    <div style={{ width: "100px", margin: "auto" }}>
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="60"
        visible={true}
      />
    </div>
  );
};

export const PopupSub = (props) => {
  console.log("sub=" + props.subStatus);
  return (
    <div className="popup-container">
      <div className="popup1">
        {props.subStatus === 2 ? (
          <>
            <div>
              <span>
                Sorry, Your balance is low. Please rechage your <br /> number to
                access service.
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="text-center">
              <a className="popupBtnRed" onClick={() => props.redirectTo("")}>
                CLOSE
              </a>
            </div>
          </>
        ) : (
          <>
            <div>
              <span>
                Sorry, UVGaming service is available
                <br /> only for paid subscribers.
              </span>
            </div>
            <div>&nbsp;</div>
            <div className="popupDiv col-12">
              <div className="popupDivLeft col-6">
                <a className="popupBtnRed" onClick={() => props.redirectTo("")}>
                  CANCEL
                </a>{" "}
              </div>
              <div className="popupDivRight col-6">
                <a
                  className="popupBtn"
                  onClick={() => props.redirectTo("/register")}
                >
                  SUBSCRIBE
                </a>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export const Notify = (props) => {
  console.log("props=" + props);
  if (props.message) {
    if (props.type) toast.success(props.message);
    else toast.warning(props.message);
  }
  // inbuilt-notification
  /* toast.success("successful");
    // inbuilt-notification
    toast.info("GeeksForGeeks");
    // inbuilt-notification
    toast.error("Runtime error");
    // default notification
    toast("Hello Geeks");*/

  return <ToastContainer />;
};

export const Random = () => {
  let rnd = Math.floor(Math.random() * 90000) + 10000;
  return rnd + "" + Date.now();
};
export const hash = (algo, string) => {
  return crypto.subtle
    .digest(algo, new TextEncoder("utf-8").encode(string))
    .then((buf) => {
      return Array.prototype.map
        .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
        .join("");
    });
};
